import { withDevtools } from '@angular-architects/ngrx-toolkit';

export const environment = {
  production: false,
  api: {
    url: 'https://api.xemex-cloud.eu/dev',
    thirdParty: {
      googleMaps: {
        key: 'AIzaSyC1RYdF_3pc8a-nfVjXtxMzYyk8fdGYa44',
      },
    },
  },
  version: {
    number: '24.10.1',
    releaseDate: '2024-10-08T06:53:48.279Z',
  },
  branding: {
    text: {
      company: {
        name: 'Xemex',
        about:
          'Xemex is an innovative and leading technology company dedicated to the smart use of energy and offers communication solutions to monitor and manage energy streams',
        website: 'https://xemex.eu',
        mail: {
          support: 'support@xemex.eu',
          noReply: 'noreply@xemex.eu',
        },
      },
      openGraph: {
        title: 'Xemex Portal - Leading Smart Energy Management and Communication Solutions',
        url: 'https://xemex.eu',
        description:
          'Discover Xemex Portal, your gateway to innovative energy management solutions. Monitor and control energy streams with cutting-edge communication technology for smarter, more efficient energy use.',
      },
    },
    urls: {
      termsOfService: 'https://xemex.eu',
      privacyPolicy: 'https://xemex.eu/privacy-policy/',
    },
    styles: {
      colors: {
        primary: {
          main: '#16A085',
          _0: '#000000',
          _10: '#002019',
          _20: '#00382D',
          _25: '#004437',
          _30: '#005142',
          _35: '#005E4D',
          _40: '#16A085',
          _50: '#00876F',
          _60: '#1CA388',
          _70: '#45BEA2',
          _80: '#65DABC',
          _90: '#96F4D9',
          _95: '#B8FFE9',
          _98: '#E6FFF5',
          _99: '#F3FFF9',
          _100: '#FFFFFF',
          hover: '#E3F4F0',
        },
        secondary: {
          main: '#F36F22',
          _0: '#000000',
          _5: '#240900',
          _10: '#351000',
          _15: '#451800',
          _20: '#561F00',
          _25: '#682700',
          _30: '#7A3000',
          _35: '#8D3800',
          _40: '#A04100',
          _50: '#C85200',
          _60: '#EC6A1C',
          _70: '#FF8C52',
          _80: '#FFB693',
          _90: '#FFDBCC',
          _95: '#FFEDE6',
          _98: '#FFF8F6',
          _99: '#FFFBFF',
          _100: '#FFFFFF',
          hover: '#FFF3ED',
          light: '#FFF3E0',
        },
        tertiary: '#F4F4F4',
        neutral: '#8080A5',
        crimson: '#D50000',
      },
    },
  },
  storeWithDevTools: withDevtools,
  monitoring: {
    // The value for appInsightsConnectionString is injected during deployment
    appInsightsConnectionString: 'InstrumentationKey=93e33c7f-eec6-4c83-bc56-0f2db018a66b;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=35814c40-be9a-42ce-9518-c14edc00395b',
  },
};
